<template>
    <table-template ref="usedCarValuationTable" actionUrl="privateUsedCar/findUserCarValuationList.action" :queryParams="queryParams">
        <template slot="search">
            <channel-select  v-belong-to-admin   @change="onChannelChanged" placeholder="请搜索渠道来源"></channel-select>
            <el-date-picker
                    style="margin-left: 10px"
                    v-model="startEndTime"
                    type="datetimerange"
                    @change="onCreateTimeChanged"
                    range-separator="至"
                    start-placeholder="估价创建时间开始"
                    end-placeholder="估价创建时间截止">
            </el-date-picker>
            <el-input type="text" style="margin-left: 10px;width:220px;" v-model="queryParams.keyword" placeholder="搜索车型"></el-input>
            <el-button type="primary" style="margin-left: 10px" @click="$refs['usedCarValuationTable'].search()">搜索</el-button>
            <el-button @click="exportExcel()" type="warning">导出</el-button>
        </template>
        <template slot="item">
            <el-table-column prop="orderNumber" label="订单号" >
              <template scope="scope">
                {{scope.row.orderNumber}}
               <p v-if="scope.row.outNetVal">外网编号：{{scope.row.outNetVal}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="personPhone"  label="用户手机" width="180px"></el-table-column>
            <el-table-column prop="fullName"  label="估价车型" ></el-table-column>
            <el-table-column label="上牌时间/里程/上牌地">
                <template scope="scope">
                    <p>{{scope.row.regdate?scope.row.regdate.split('-')[0]+' 年':'暂无'}} | {{scope.row.miles?scope.row.miles+' 万公里':'暂无'}} | {{scope.row.city}}</p>
                </template>
            </el-table-column>
            <el-table-column label="估价结果" width="180px">
                <template scope="scope">
                    <p>估售价：{{scope.row.valuationPrice?scope.row.valuationPrice+'万':'暂无'}}</p>
                    <p>新车价：{{scope.row.officePrice?scope.row.officePrice+'万':'暂无'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="sourceName"  label="渠道来源" width="180px"></el-table-column>
            <el-table-column prop="areaName"  label="所属区域" width="180px"></el-table-column>
            <el-table-column  label="创建时间" width="180px">
                <template scope="scope">
                    <span>{{scope.row.createTime | dateTimeFormat}}</span>
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import channelSelect from '@/components/channelSelect'
import tableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  extends: BasicPager,
  components: {
    channelSelect,
    tableTemplate
  },
  data () {
    return {
      isAdmin: false,
      channelId: null,
      queryParams: {},
      startEndTime: []
    }
  },
  created: function () {
    let userInfo = this.getLoginInfo()
    this.isAdmin = userInfo.loginPath !== 'channel'
    if (!this.isAdmin) {
      this.channelId = this.loginInfo.id
    }
  },
  methods: {
    exportExcel: function () {
      let that = this
      // 验证用户登录状态
      let userInfo = this.getLoginInfo()
      if (!userInfo) {
        this.$message('您没有登录哦！')
        return
      }

      let loginPath = userInfo.loginPath

      let param = {
        keyword: that.queryParams.keyword,
        startTime: that.queryParams.startTime,
        endTime: that.queryParams.endTime
      }
      let dataStr = ''

      for (var key in param) {
        if (param.hasOwnProperty(key)) {
          if (!param[key]) {
            continue
          }

          dataStr += '&' + key + '=' + param[key] + ''
        }
      }
      if (!that.isAdmin) {
        dataStr += '&channelId=' + that.channelId + ''
      }

      let id = userInfo.employeeId
      window.location.href = Config.baseUrl + 'privateUsedCar/exportExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    },
    onCreateTimeChanged (dates) {
      if (dates && dates.length == 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs['usedCarValuationTable'].search()
    },
    onChannelChanged (channelId) {
      this.queryParams.channelId = channelId
      this.$refs['usedCarValuationTable'].search()
    }
  }
}
</script>
